export const EXAM_IELTS = 22;
export const EXAM_TOEFL = 23;
export const EXAM_GMAT = 24;
export const EXAM_GRE = 25;
export const EXAM_TOEIC = 129;
export const EXAM_ACT = 478;
export const EXAM_SAT = 661;
export const EXAM_CET = 671;
export const EXAM_PTE = 1863;

export const EXAM_JP_JLPT = 89;
export const EXAM_JP_J_TEST = 90;
export const EXAM_JP_BJT = 91;
export const EXAM_JP_NAT = 92;

export default [
  EXAM_IELTS,
  EXAM_TOEFL,
  EXAM_GMAT,
  EXAM_GRE,
  EXAM_TOEIC,
  EXAM_ACT,
  EXAM_SAT,
  EXAM_CET,
  EXAM_PTE,
  EXAM_JP_JLPT,
  EXAM_JP_J_TEST,
  EXAM_JP_BJT,
  EXAM_JP_NAT,
];
